export default __webpack_public_path__ + "static/media/yosemite.91629375.jpg";